'use strict';

angular.module('user')
    .component('signupForm', {
        templateUrl: 'js/modules/user/components/signup-form/template.html',
        controller: 'UserSignupController',
        bindings: {
            invitation: '<',
            onPendingSignUp: '&',
            onActiveSignUp: '&',
        },
    });
